import axiosInstance from "@/api/axios-instance";

export async function updateUsageUser(usage_id: string, user_id?: string | null) {
  const response = await axiosInstance.patch(`/usage/update-usage-user`, {
    usage_id,
    user_id,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update usage user");
  }

  return response.data;
}
